export default "__VITE_ASSET__BZr3JFXt__"